
import createNumberMask from 'text-mask-addons/dist/createNumberMask.js';

class CalculatorPageController {
  constructor($window) {
    this.name = 'calculator.page';
    this.$window = $window;
  }

  $onInit(){
    this.$window.scrollTo(0, 0);
    // set the currency mask for currency inputs
    this.numberMask = createNumberMask({
      prefix: '$',
      allowDecimal: true
    });
    this.textMaskConfig = {
      mask:this.numberMask
    };

    // reset the invalid flag for all the fields
    this.fields.map(f => {
      f.invalid = false;
    });
  }

  next(){
    let invalid = this.fields.map(f => {
      f.invalid = !f.isValid(this.fields);
      return f;
    }).reduce((b, f) => {
      return b || f.invalid;
    }, false);
    if(!invalid) this.goNext(); // execute parent function to update page if all the fields are valid
  }

  back(){
    this.goBack(); // execute parent function to update page
  }
}

CalculatorPageController.$inject = ['$window'];

export default CalculatorPageController;



// WEBPACK FOOTER //
// ./client/app/components/calculator/calculator.page/calculator.page.controller.js